import { HelpOutline } from '@mui/icons-material';
import { Dialog, DialogContent, Divider, Paper } from '@mui/material';
import { PaperProps } from '@mui/material/Paper/Paper';
import { uniqueId } from 'lodash';
import React, { useState } from 'react';
import Draggable from 'react-draggable';

import { SanitizeHTML } from '~/components/SanitizeHTML';
import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';

import { useSxStyles } from './useStyles';

export type InstructionDialogProps = {
  open: boolean;
  title: string;
  richTextContent?: string;
  children?: React.ReactNode;
  onClose: () => void;
};
export const InstructionDialog = (props: InstructionDialogProps) => {
  const { open, title, richTextContent, children, onClose } = props;
  const sxStyles = useSxStyles();

  const [dialogId] = useState(uniqueId('draggable-dialog-'));

  const DraggableDialogPaperComponent = (paperProps: PaperProps) => {
    return (
      <Draggable
        handle={`#${dialogId}`}
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...paperProps} />
      </Draggable>
    );
  };

  const renderContent = (): React.ReactNode => {
    if (typeof richTextContent === 'string') {
      return <SanitizeHTML html={richTextContent} />;
    }

    return <>{children}</>;
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={'xl'}
      PaperComponent={DraggableDialogPaperComponent}
      PaperProps={{
        style: sxStyles.dialogSize,
      }}
      aria-labelledby={dialogId}
    >
      <SolaForceDialogTitle
        icon={<HelpOutline />}
        onClose={onClose}
        id={dialogId}
      >
        {title}
      </SolaForceDialogTitle>
      <Divider />
      <DialogContent>{renderContent()}</DialogContent>
    </Dialog>
  );
};
